import { render, staticRenderFns } from "./ModuleDetail.vue?vue&type=template&id=4d8a42cf&scoped=true"
import script from "./ModuleDetail.vue?vue&type=script&lang=js"
export * from "./ModuleDetail.vue?vue&type=script&lang=js"
import style0 from "./ModuleDetail.vue?vue&type=style&index=0&id=4d8a42cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a42cf",
  null
  
)

export default component.exports